import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { Loja } from 'pages/cadastro/loja/types';

export function useQueryLojas() {
    const requestListagem = useRequestListagem();
    const { page, sort, limit, filter } = useListagemContext();

    const requestOptions: RequestOptionsType = {
        url: '/gestao/loja',
        columns: 'idLoja,cdLoja,dsRazaoSocial,dsNomeFantasia,dsCnpj,dsGrupoEconomico,sgEstado,dsCidade,dsTipoLoja,fgAtivo,dsLojaPerfil',
        sort: sort?.length ? sort : [{ property: 'idLoja', direction: 'DESC' }],
        page,
        filter,
        limit,
    };

    return useQuery<RequestListagem<Loja[]>>({
        queryKey: ['lojas', requestOptions],
        queryFn: () => requestListagem(requestOptions).then((res) => res.data),
    });
}
